export default "__VITE_ASSET__DZSM50MS__"